import { AfterViewChecked, AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-terms',
  imports: [],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.css'
})
export class TermsComponent implements AfterViewInit{

  ngAfterViewInit(): void {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
